<template>
  <button class="light-box-cross" @click="closeLightBox">
    <ul class="light-box-cross__list">
      <li></li>
      <li></li>
    </ul>
  </button>
</template>

<script>
export default {
  methods: {
    closeLightBox() {
      this.$store.commit("lightBox/TOGGLE_LIGHT_BOX", false);
      this.$store.commit("lightBox/UPDATE_YOUTUBE_ID", null);
    }
  }
};
</script>

<style lang="scss">
.light-box-cross {
  @include resetBtn;
  position: absolute;
  top: 0;
  right: 0;
  padding: 3px;
  cursor: pointer;
  z-index: 10;
  &__list {
    @include reset-list;
    display: flex;
    flex-direction: column;
    height: 50px;
    width: 50px;
    position: relative;
    li {
      @include transition(0.3s ease all);
      /* @include transform(translate(0px 25px)); */
      width: 50px;
      height: 8px;
      background: $color-dark;
      position: absolute;
      top: 20px;
      &:nth-child(1) {
        @include rotate(45deg);
        /* transform-origin: 0% 50%; */
        .light-box-cross:hover & {
          @include rotate(-45deg);
        }
      }
      &:nth-child(2) {
        @include rotate(-45deg);
        .light-box-cross:hover & {
          @include rotate(45deg);
        }
      }
    }
  }
}
</style>
